// Latin combining marks, Arabic harakat (NFD turns hamza and madda on alef into these), superscript alef, tatweel.
const IGNORED_MARKS = /[\u0300-\u036f\u064b-\u065f\u0670\u0640]/g;
const ALEF_WASLA = /\u0671/g;
const APOSTROPHES = /[\u2018\u2019\u02bc]/g;

export function normalizeSearchText(value: string | null | undefined): string {
  return (value || '')
    .normalize('NFD')
    .toLowerCase()
    .replace(IGNORED_MARKS, '')
    .replace(ALEF_WASLA, '\u0627')
    .replace(APOSTROPHES, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

export function matchesSearchText(text: string | null | undefined, query: string | null | undefined): boolean {
  const normalizedQuery = normalizeSearchText(query);
  return normalizedQuery.length > 0 && normalizeSearchText(text).includes(normalizedQuery);
}
